import React, { Component } from "react";
import Modal from "react-modal";
import { Redirect } from "react-router-dom";
import axios from "axios";
import Select from "react-select";
import "../../common.css";

import LoadingPage from "../../../components/Loading/Loading";
import config from "../../../config";
import errorFunctions from "../../../store/errorFunctions";
import utilityFunctions from "../../../store/utilityFunctions";
import "./StaffDetail.css";
Modal.setAppElement("body");
const cin7Options = [
  { label: "None", value: "no_access" },
  { label: "Partial", value: "partial" },
  { label: "All", value: "all" },
];
export default class StaffDetail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      details: null,
      id: null,
      showApproveModal: false,
      showDeclineModal: false,
      addComment: "",
      startPostageNumber: "",
      endPostageNumber: "",
      showDeleteModal: false,
      redirect: false,
      showOutOfWarrantyModal: false,
      showAddNote: false,
      addedNote: "",
      employee: null,
      ticketID: null,
      employeeID: null,
      storeLocationLabel: "",
      currentStoreLocationId: "",
      storeLocationId: "",
      storeLocationChanged: false,
      showAssignModal: false,
      statusTicket: "",
      modalStatusConfirm: false,
      brands: [],
      roles: [],
      currentRole: "",
      name: "",
      email: "",
      cin7Name: "",
      isSubemo: false,
      cin7Access: { label: "None", value: "none" },
    };
  }

  componentDidMount() {
    const id = this.props.computedMatch.params.id;
    this.setState({ id });
    this.retriveDetailStaff(id);
    this.retriveAllBrand();
    this.retriveAllRoles();
    this.retrieveStoreLocation();
  }
  retriveDetailStaff = (id) => {
    this.setState({ loading: true });
    this.props
      .protectedFetch(
        config.backendServer + "employee/" + id + "/",
        "GET",
        null,
        errorFunctions.checkResponseThenJson
      )
      .then((res) => {
        this.setState({
          loading: false,
          details: res,
          isSubemo: res.is_subemo,
          cin7Access: cin7Options.find((x) => x.value === res.cin7_access),
          currentRole: res.user_role,
          storeLocationLabel: res.seller.name + " - " + res.store_location.name,
        });
      })
      .catch(() => {
        console.log("fail");
        this.setState({ loading: false });
      });
  };

  retriveAllBrand = () => {
    this.setState({ loading: true });
    this.props
      .protectedFetch(
        config.backendServer + "brands/",
        "GET",
        null,
        errorFunctions.checkResponseThenJson
      )
      .then((res) => {
        this.setState({ loading: false, brands: res });
      })
      .catch(() => {
        console.log("fail brand");
        this.setState({ loading: false });
      });
  };

  deleteUserLocation = () => {
    let url = `${config.backendServer}store_location/${this.state.currentStoreLocationId}/remove_staff/${this.state.details.id}/`;
    const userInfo =
      localStorage.getItem("userInfo") ||
      utilityFunctions.getCookie("userInfo");
    const token = userInfo?.access_token || JSON.parse(userInfo)?.access_token;
    const options = {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    };

    fetch(url, options).then((response) => {
      console.log(response.status);
      if (response.status === 204) {
        this.setState({ showConfirmDelete: false, loading: false });
        if (this.state.storeLocationId)
          this.addUserLocation(this.state.details.id);
      } else if (response.status === 406) {
        alert(
          `Delete is not allowed, User Service Center is already linked to ticket`
        );
      } else if (response.status === 409) {
        alert(`User Service does not exist.`);
      } else {
        alert("Problem with system. Please refresh and try again later.");
      }
    });
  };

  addUserLocation = (userId) => {
    this.setState({ loading: true });
    if (!userId && !this.state.storeLocationId) {
      alert("User is not selected");
      return;
    }
    let payload = {
      employee_id: this.state.details.id,
    };
    const userInfo =
      localStorage?.getItem("userInfo") ||
      utilityFunctions?.getCookie("userInfo");
    const token = (userInfo && JSON?.parse(userInfo)?.access_token) || "";
    let options = {
      headers: {
        Authorization: "Bearer " + token,
      },
    };

    axios
      .post(
        `${config.backendServer}store_location/${this.state.storeLocationId}/add_staff/`,
        payload,
        options
      )
      .then((res) => {
        let tempUsers = [...this.state.data];
        tempUsers.push(res.data);
        this.setState({
          loading: false,
          showAddUser: false,
          data: tempUsers,
          employeeID: "",
        });
      })
      .catch(() => {
        this.setState({ loading: false });
        console.log("service user failed");
        //   resolve(err);
      });
  };

  retriveAllRoles = () => {
    this.setState({ loading: true });
    this.props
      .protectedFetch(
        config.backendServer + "roles/",
        "GET",
        null,
        errorFunctions.checkResponseThenJson
      )
      .then((res) => {
        this.setState({ loading: false, roles: res });
      })
      .catch(() => {
        console.log("fail brand");
        this.setState({ loading: false });
      });
  };

  handleSubmit = () => {
    this.setState({ loading: true });

    const id = this.props.computedMatch.params.id;
    const selectedBrandIds = Array.from(
      document.querySelectorAll("input[type='checkbox']:checked")
    ).map((checkbox) => parseInt(checkbox.value));

    let payload = {
      brands: selectedBrandIds,
      name: this.state.name || this.state.details.name,

      email: this.state.email || this.state.details.email,
      user_role: this.state.currentRole || this.state.details.user_role,
      is_subemo: this.state.isSubemo,
      cin7_access: this.state.cin7Access.value,
      cin7_name: this.state.cin7Name || this.state.details.cin7Name,
    };

    this.props
      .protectedFetch(
        config.backendServer + `employee/${id}/`,
        "PUT",
        payload,
        errorFunctions.checkResponseThenJson
      )
      .then(() => {
        if (
          this.state.storeLocationChanged &&
          this.state.currentStoreLocationId
        )
          this.deleteUserLocation();
        else if (this.state.storeLocationChanged && this.state.storeLocationId)
          this.addUserLocation(this.state.details.id);
        this.setState({
          name: "",
          email: "",
          // storeLocationId: "",
          // storeLocationLabel: "",
          currentRole: "",
          loading: false,
          redirect: true,
        });

        this.retriveDetailStaff(id); //mini reload
      })
      .catch((e) => {
        alert(JSON.stringify(e));
        console.log("fail");

        this.setState({
          loading: false,
        });
      });
  };

  retrieveStoreLocation = () => {
    this.setState({
      isLoading: true,
      // deviceId: brandDevice[0]?.id,
    });
    this.props
      .protectedFetch(
        config.backendServer + "store_locations/",
        "GET",
        { country: config.country },
        errorFunctions.checkResponseThenJson
      )
      .then((res) => {
        const options = res.map((r) => {
          return { label: r.seller_name + " - " + r.name, value: r.id };
        });

        this.setState({
          sellers: res,
          filteredSellers: res,
          isLoading: false,
          locationOptions: [...[{ label: "---", value: "" }], ...options],
          selectedSeller: options.find((s) => s.value === res[0].id),
          // stores: res[0].store_locations,
          // deviceId: brandDevice[0]?.id,
        });
        // this.retrieveStore(res[0].id);
      })
      .catch((err) => console.log(err));
  };

  handleRole = (e) => {
    this.setState({ currentRole: e.target.value });
  };
  handleChange = (e) => {
    this.setState({ [e.target.id]: e.target.value });
  };
  render() {
    if (this.state.redirect) {
      // Redirect only occurs when its a super user
      return <Redirect to={"/manage-staff"} />;
    } else if (this.state.loading) {
      return <LoadingPage />;
    } else if (!this.state.details) {
      return (
        <div className={"page"}>
          <h2 className={"pageHeader"}>Error - page not found</h2>
        </div>
      );
    }
    const locValue = this.state.locationOptions?.find(
      (loc) => loc.label === this.state.storeLocationLabel
    );
    const details = this.state.details || {};

    return (
      <div className={"page"}>
        <div className="card">
          <h4 className={"card-header"}>Staff Detail #{details?.id}</h4>

          <form onSubmit={this.handleSubmit}>
            <div className="card-body">
              <div className="row">
                <div className="col-6">
                  <div className={"single-warranty-details-item"}>
                    <span className={"single-warranty-details-label"}>
                      Full name:
                    </span>
                    <input
                      type="text"
                      id="name"
                      required={true}
                      defaultValue={this.state.fullName || details.name}
                      className="form-control"
                      onChange={this.handleChange}
                    />
                  </div>

                  <div className={"single-warranty-details-item"}>
                    <label className={"single-warranty-details-label"}>
                      CIN 7 Access<span>:</span>
                    </label>
                    <Select
                      required
                      id="cin7Access"
                      options={cin7Options}
                      value={this.state.cin7Access}
                      placeholder="Select CIN7 access"
                      onChange={(e) => {
                        this.setState({
                          cin7Access: e,
                        });
                      }}
                      // onInputChange={(val) => this.searchLocationState(val)}
                    />
                  </div>

                  {/* <div className={"single-warranty-details-item"}>
                    <div className={"single-warranty-details-item"}>
                      <label className={"single-warranty-details-label"}>
                        <span>CIN7 Name :</span>
                      </label>
                      <input type="text" id="cin7Name" className="form-control" onChange={this.handleChange} defaultValue={details.cin7_name} />
                    </div>
                  </div> */}

                  <div className={"single-warranty-details-item"}>
                    <span className={"single-warranty-details-label"}>
                      Email:
                    </span>
                    <input
                      type="email"
                      id="email"
                      required={true}
                      defaultValue={details.email}
                      className="form-control"
                      onChange={this.handleChange}
                    />
                  </div>

                  <div className={"single-warranty-details-item"}>
                    <span className={"single-warranty-details-label"}>
                      Brands:
                    </span>
                    <span>
                      {this.state.brands.map((brand) => (
                        <div className="col-6" key={brand.id}>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id={`brand-${brand.id}`}
                              defaultChecked={this.state.details.brands.some(
                                (activeBrand) => activeBrand.id === brand.id
                              )}
                              value={brand.id}
                            />
                            <label
                              className="form-check-label"
                              htmlFor={`brand-${brand.id}`}
                            >
                              {brand.name}
                            </label>
                          </div>
                        </div>
                      ))}
                    </span>
                  </div>

                  <div className={"single-warranty-details-item"}>
                    <span className={"single-warranty-details-label"}>
                      Role:
                    </span>
                    <span className="container d-flex gap-2">
                      <select
                        className="form-control custom-select"
                        value={this.state.currentRole}
                        onChange={this.handleRole}
                      >
                        {this.state?.roles
                          ?.filter((r) => r.name !== "Commercial Staff")
                          .map((val, i) => {
                            return (
                              <option key={i} id="currentRole" value={val.name}>
                                {val.name}
                              </option>
                            );
                          })}
                      </select>
                      {this.state.currentRole === "Staff" && (
                        <div className="form-check my-auto">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="isSubemo"
                            checked={this.state.isSubemo}
                            onChange={(e) => {
                              console.log(e.target);
                              this.setState({ isSubemo: e.target.checked });
                            }}
                          />
                          <label className="form-check-label">Subemo</label>
                        </div>
                      )}
                    </span>
                  </div>
                  <div className={"single-warranty-details-item"}>
                    <label className={"single-warranty-details-label"}>
                      Store Location<span>:</span>
                    </label>
                    <Select
                      required
                      options={this.state.locationOptions}
                      value={locValue}
                      placeholder="Select Location"
                      onChange={(e) => {
                        const curStoreLocId =
                          this.state.locationOptions.find(
                            (l) => l.label === this.state.storeLocationLabel
                          )?.value || "";
                        this.setState({
                          currentStoreLocationId: curStoreLocId,
                          storeLocationId: e.value,
                          storeLocationLabel: e.label,
                          storeLocationChanged: curStoreLocId !== e.value,
                        });
                      }}
                      // onInputChange={(val) => this.searchLocationState(val)}
                    />
                  </div>
                </div>
                <div className="col-6">
                  <h5>List service center:</h5>
                  {details?.service_center?.length > 0 ? (
                    <ul className="list-group">
                      {details?.service_center?.map((sc, i) => {
                        return (
                          <li className="list-group-item" key={i}>{`${
                            i + 1
                          }.  ${sc.name}`}</li>
                        );
                      })}
                    </ul>
                  ) : (
                    <div>No Data</div>
                  )}
                </div>
              </div>
            </div>
            <div className="card-footer">
              <div className="row">
                <div className="col-3">
                  <button className={"btn btn-outline-primary"}>
                    Save Data
                  </button>
                </div>
                <div className="col-3">
                  <a
                    className={"btn btn-outline-secondary"}
                    href={"/manage-staff"}
                  >
                    Close
                  </a>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
